import React from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
function StandardInputHOC(Component, validationData) {
  if (validationData === void 0) {
    validationData = {};
  }
  class StandardInput extends React.Component {
    constructor() {
      super();
      this.isValid = this.isValid.bind(this);
    }
    getValue() {
      return this._standardInput._input.getValue();
    }
    isValid() {
      return this._standardInput._input.isValid();
    }
    render() {
      const {
        name,
        validations,
        validationError,
        validationErrors,
        forwardedRef,
        ...rest
      } = this.props;
      const standardAttributes = {
        name,
        noValidate: true,
        autoCorrect: 'off',
        validations: {
          ...validationData.validations,
          ...validations
        },
        validationError: validationError || validationData.validationError,
        validationErrors: {
          ...validationData.validationErrors,
          ...validationErrors
        }
      };
      return /*#__PURE__*/_jsx(Component, {
        ref: forwardedRef,
        ...standardAttributes,
        ...rest
      });
    }
  }
  return /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx(StandardInput, {
    ...props,
    forwardedRef: ref
  }));
}
export default StandardInputHOC;